// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"App_pageWrapper__1Jej4"};